import React from "react";
import "./fasilitas.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Fasilitasimages from "./fasilitas";
import {faCheckDouble} from "@fortawesome/free-solid-svg-icons";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

const settings1 = {
  dots: true,
  arrows: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
};
const About = () => {
  const handleConsultationClick = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6287874691787&text=Halo%20Heldy,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Summarecon%20Bogor%20(Fasilitas)%20https://marketingrumahbogor.com//&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };

  return (
    <div className="about">
      <div id="fasilitas" className="container-about">
        <h1>Living Life With Everything You Need Around the Corner</h1>
        <hr />
        <div className="container-desk">
          <div className="desk">
            Untuk meningkatkan kenyamanan serta memenuhi kebutuhan penghuninya,
            Summarecon Bogor menawarkan berbagai macam fasilitas, seperti :
          </div>
        </div>
        <div className="container-benefit">
          <div className="benefit-list">
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "white"}}>&nbsp;&nbsp;One Gate System</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "white"}}>&nbsp;&nbsp;Clubhouse</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "white"}}>
                &nbsp;&nbsp;Children Playground
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "white"}}>&nbsp;&nbsp;Swimming Pool</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "white"}}>
                &nbsp;&nbsp;Security 24 Hours
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "white"}}>&nbsp;&nbsp;Golf Course</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "white"}}>&nbsp;&nbsp;Jogging Track</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "white"}}>
                &nbsp;&nbsp;3 on 3 Basketball Court
              </span>
            </div>
          </div>
        </div>
        <div className="button">
          <div className="container-wa">
            <button
              className="buttonpenawaran"
              onClick={handleConsultationClick}>
              Learn More
            </button>
          </div>
        </div>
      </div>

      <div className="slider-regia">
        <Slider {...settings1}>
          {Fasilitasimages.map((image, index) => (
            <img className="imagecard" key={index} src={image} />
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default About;
